/**
 * @file Confirmation modal.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withModal from './modal/withModal';
import { CONFIRM_MODAL } from '../../constants/modals';
import Button from './Button';
import CustomControl from './CustomControl';

class ConfirmDialog extends Component {
  static propTypes = {
    actionProps: PropTypes.shape({
      message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      confirmText: PropTypes.string,
      cancelText: PropTypes.string,
      onConfirm: PropTypes.func.isRequired,
      onCancel: PropTypes.func,
      confirmBtnStyle: PropTypes.string,
      showDoNotShowAgain: PropTypes.bool,
    }),
    // This is not required because we can use the component on its own
    // rather than with the `withModal` HOC.
    onRequestClose: PropTypes.func,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
      PropTypes.string,
    ]),
  };

  state = {
    doNotShowAgain: false,
  };

  onConfirm = () => {
    const {
      actionProps: { onConfirm, showDoNotShowAgain },
      onRequestClose,
    } = this.props;

    const { doNotShowAgain } = this.state;

    if (onRequestClose) {
      onRequestClose();
    }

    onConfirm(showDoNotShowAgain ? doNotShowAgain : undefined);
  };

  onCancel = () => {
    const {
      actionProps: { onCancel },
      onRequestClose,
    } = this.props;

    if (onRequestClose) {
      onRequestClose();
    }

    if (onCancel) {
      onCancel();
    }
  };

  toggleShowAgain = () => {
    const { doNotShowAgain } = this.state;
    this.setState(() => ({ doNotShowAgain: !doNotShowAgain }));
  };

  render() {
    const {
      actionProps: {
        message = 'Are you sure you want to do this?',
        confirmText = 'OK',
        cancelText = 'Cancel',
        confirmBtnStyle = 'primary',
        cancelBtnStyle = 'primary',
        confirmBtnOutline = false,
        showDoNotShowAgain = false,
        onCancel,
      },
      children,
    } = this.props;

    const { doNotShowAgain } = this.state;

    return (
      <div>
        {typeof message === 'string' ? <p>{message}</p> : message}

        {children}

        <div className="modal-footer">
          <div className="d-flex flex-column flex-sm-row">
            {onCancel && (
              <Button
                btnSize="sm"
                btnStyle={cancelBtnStyle}
                btnOutline
                btnBlock
                className="text-transform-none text-base mr-0 mr-sm-2 mb-2 mb-sm-0"
                onClick={this.onCancel}
              >
                {cancelText}
              </Button>
            )}

            <Button
              btnSize="sm"
              btnBlock
              className="text-transform-none text-base mt-0"
              btnStyle={confirmBtnStyle}
              btnOutline={confirmBtnOutline}
              onClick={this.onConfirm}
            >
              {confirmText}
            </Button>
          </div>

          {showDoNotShowAgain && (
            <CustomControl
              id="do-not-show-modal"
              type="checkbox"
              label="Do not show this message again"
              size="sm"
              className="mt-2"
              checked={doNotShowAgain}
              onChange={() => this.toggleShowAgain()}
            />
          )}
        </div>
      </div>
    );
  }
}

export { ConfirmDialog as ConfirmDialogComp };

export default withModal(ConfirmDialog, {
  name: CONFIRM_MODAL,
  size: 'sm',
  hideHeader: true,
  overlayClassName: 'modal-overlay-max',
});
